import React from 'react'
import SEO from 'components/atoms/seo'
import Hero from 'components/molecules/Hero'
import { Text } from 'components/atoms/Typography'
import Container from 'components/atoms/Container'
import GenericPage from 'routes/components/pages/GenericPage'

const AboutUs = () => (
  <GenericPage>
    <SEO title="About us" />
    <Hero>About us</Hero>
    <Container.Narrow>
      <Text.Block mb="xl">
        <Text>
          Our Mission is to provide an opportunity for home ownership to all. We
          at NuNu have developed a new product for home buyers with the goal of
          making the dream of home ownership possible. NuNu is revolutionizing
          the way that mortgage applications are being taken and processed.
          Using the best technology, giving the applicant access from any mobile
          device. We pride ourselves on a higher level of continued service
          throughout the financing process.
        </Text>
        <Text>
          At NuNu our goal is to make the American dream possible with
          simplicity and confidence. Nunu will finance the entire purchase price
          and eliminate the need for a down payment, making your dream of home
          ownership attainable. We have joined to create a product that we
          believe is in the best interest of our customers. Allowing them to
          overcome the barriers in the real estate market and achieve the
          American Dream of homeownership.
        </Text>
        <Text>
          NuNu Financial, LLC is powered by Crescent Heights. Crescent Heights
          is a multi-national real estate developer with close to 40 years of
          residential ownership experience to guide NuNu Financial. With the
          same goals in place, we are striving to make homeowner possible to as
          many families as possible in a fair, transparent, and seamless manner.
        </Text>
      </Text.Block>
    </Container.Narrow>
  </GenericPage>
)

export default AboutUs
